
export const CURRENT_CITY='CURRENT_CITY'
export const CITY_ERROR = 'CITY_ERROR'
